import { UserNotificationsComponent } from './../shared/components/user-notifications/user-notifications.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardChangePasswordComponent } from './components/dashboard-change-password/dashboard-change-password.component';
import { DashboardManageJobsComponent } from './components/dashboard-manage-jobs/dashboard-manage-jobs.component';
import { DashboardPricingPlanComponent } from './components/dashboard-pricing-plan/dashboard-pricing-plan.component';
import { DashboardCandidateMainComponent } from './components/candidate/dashboard-main/dashboard-main.component';
import { DashboardEmployerMainComponent } from './components/employer/dashboard-main/dashboard-main.component';
import { DashboardCandidateMenuComponent } from './components/candidate/dashboard-menu/dashboard-menu.component';
import { DashboardEmployerMenuComponent } from './components/employer/dashboard-menu/dashboard-menu.component';
import { DashboardCandidateSummaryComponent } from './components/candidate/dashboard-summary/dashboard-summary.component';
import { DashboardCandidateProfileComponent } from './components/candidate/dashboard-profile/dashboard-profile.component';
import { DashboardEmployerProfileComponent } from './components/employer/dashboard-profile/dashboard-profile.component';
import { DashboardCandidateResumeComponent } from './components/candidate/dashboard-resume/dashboard-resume.component';
import { DashboardCandidateSavedJobsComponent } from './components/candidate/dashboard-saved-jobs/dashboard-saved-jobs.component';
import { DashboardEmployerPostNewJobComponent } from './components/employer/dashboard-post-new-job/dashboard-post-new-job.component';
import { DashboardEmployerManageCandidatesComponent } from './components/employer/dashboard-manage-candidates/dashboard-manage-candidates.component';
import { DashboardEmployerSummaryComponent } from './components/employer/dashboard-summary/dashboard-summary.component';
import { JobSkillsFormComponent } from './components/employer/dashboard-post-new-job/skills-form/skills-form.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { SkillsFormComponent } from './components/candidate/dashboard-resume/skills-form/skills-form.component';
import { SharedModule } from '../shared/shared.module';
import { JobsModule } from '../jobs/jobs.module';
import { CandidatesModule } from '../candidates/candidates.module';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CertificateFormComponent } from './components/candidate/dashboard-resume/certificate-form/certificate-form.component';
import { PortfolioAttachmentComponent } from './components/candidate/dashboard-resume/portfolio-attachment/portfolio-attachment.component';
import { DashboardJobInvitesComponent } from './components/candidate/dashboard-job-invites/dashboard-job-invites.component';
import { CanDeactivateGuard } from '../shared/guards/candecactivate.route.gaurd';
import { ChangePasswordAlertComponent } from './components/dashboard-change-password/change-password-alert/change-password-alert.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { JobResolverService } from '../jobs/job-resolver.service';

const routes: Routes = [
  {
    path: 'candidate',
    component: DashboardCandidateMainComponent,
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      { path: 'manage-jobs', component: DashboardCandidateSummaryComponent,resolve:{jobs:JobResolverService} },
      { path: 'job-invites', component: DashboardJobInvitesComponent },
      {
        path: 'profile',
        component: DashboardCandidateProfileComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      { path: 'change-password', component: DashboardChangePasswordComponent },
      { path: 'resume', component: DashboardCandidateResumeComponent },
      { path: 'saved-jobs', component: DashboardCandidateSavedJobsComponent },
      { path: 'pricing-plan', component: DashboardPricingPlanComponent },
      { path: 'notifications', component: UserNotificationsComponent }
    ],
  },
  {
    path: 'employer',
    component: DashboardEmployerMainComponent,
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      { path: 'manage-jobs', component: DashboardManageJobsComponent },
      {
        path: 'profile',
        component: DashboardEmployerProfileComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      { path: 'change-password', component: DashboardChangePasswordComponent },
      {
        path: 'manage-candidates',
        component: DashboardEmployerManageCandidatesComponent,
      },
      { path: 'post-job', component: DashboardEmployerPostNewJobComponent },
      { path: 'pricing-plan', component: DashboardPricingPlanComponent },
      { path: 'notifications', component: UserNotificationsComponent }
    ],
  },
];

@NgModule({
  declarations: [
    DashboardCandidateMainComponent,
    DashboardEmployerMainComponent,
    DashboardCandidateMenuComponent,
    DashboardEmployerMenuComponent,
    DashboardCandidateSummaryComponent,
    DashboardEmployerSummaryComponent,
    DashboardChangePasswordComponent,
    DashboardCandidateProfileComponent,
    DashboardEmployerProfileComponent,
    DashboardCandidateResumeComponent,
    DashboardManageJobsComponent,
    DashboardCandidateSavedJobsComponent,
    DashboardPricingPlanComponent,
    DashboardEmployerManageCandidatesComponent,
    DashboardEmployerPostNewJobComponent,
    SkillsFormComponent,
    CertificateFormComponent,
    PortfolioAttachmentComponent,
    JobSkillsFormComponent,
    DashboardJobInvitesComponent,
    ChangePasswordAlertComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SharedModule,
    PasswordStrengthMeterModule,
    JobsModule,
    CandidatesModule,
    NgxDocViewerModule,
    NgMultiSelectDropDownModule,
    NgSelectModule
  ],
  exports: [DashboardEmployerPostNewJobComponent],
})
export class DashboardsModule {}
